"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var actionCreators_1 = require("../../actionCreators");
var defaultOptions_1 = __importDefault(require("../../defaultOptions"));
var ComponentUtils_1 = require("../../Utils/ComponentUtils");
var PopupContentItem = function (props) {
    var _a, _b, _c;
    var column = props.column, childComponents = props.childComponents, dispatch = props.dispatch, item = props.item;
    var checked = (_b = (_a = column.headerFilterValues) === null || _a === void 0 ? void 0 : _a.includes(item), (_b !== null && _b !== void 0 ? _b : false));
    var handleChange = function (event) {
        dispatch(actionCreators_1.updateHeaderFilterValues(column.key, item, event.currentTarget.checked));
    };
    var _d = ComponentUtils_1.getElementCustomization({
        className: "" + defaultOptions_1.default.css.popupContentItem
    }, props, (_c = childComponents) === null || _c === void 0 ? void 0 : _c.popupContentItem), elementAttributes = _d.elementAttributes, content = _d.content;
    return (React.createElement("div", __assign({}, elementAttributes), content || (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'ka-popup-content-checkbox' },
            React.createElement("input", { className: 'ka-input', type: 'checkbox', checked: checked, onChange: handleChange })),
        React.createElement("div", { className: 'ka-popup-content-item-value' }, item)))));
};
exports.default = PopupContentItem;
